const videos2025 = [
  {
    id: 1,
    title: {
      english: "Video Gallery 2025 - Video 1",
      marathi: "व्हिडिओ गॅलरी २०२५ - व्हिडिओ १"
    },
    description: {
      english: "Board program video from 2025",
      marathi: "२०२५ मधील मंडळ कार्यक्रम व्हिडिओ"
    },
    year: 2025,
    videoUrl: "https://mlwb.in/react-static-files/videos/gallery/video-2025-1.mp4",
    thumbnail: "https://mlwb.in/react-static-files/videos/gallery/thumbnails/video-2025-1.webp",
    poster: "https://mlwb.in/react-static-files/videos/gallery/thumbnails/video-2025-1.webp",
    type: "direct",
    date: "2025-01-15"
  },
  {
    id: 2,
    title: {
      english: "Video Gallery 2025 - Video 2",
      marathi: "व्हिडिओ गॅलरी २०२५ - व्हिडिओ २"
    },
    description: {
      english: "Board program video from 2025",
      marathi: "२०२५ मधील मंडळ कार्यक्रम व्हिडिओ"
    },
    year: 2025,
    videoUrl: "https://mlwb.in/react-static-files/videos/gallery/video-2025-2.mp4",
    thumbnail: "https://mlwb.in/react-static-files/videos/gallery/thumbnails/video-2025-2.webp",
    poster: "https://mlwb.in/react-static-files/videos/gallery/thumbnails/video-2025-2.webp",
    type: "direct",
    date: "2025-02-15"
  },
  {
    id: 3,
    title: {
      english: "Video Gallery 2025 - Video 3",
      marathi: "व्हिडिओ गॅलरी २०२५ - व्हिडिओ ३"
    },
    description: {
      english: "Board program video from 2025",
      marathi: "२०२५ मधील मंडळ कार्यक्रम व्हिडिओ"
    },
    year: 2025,
    videoUrl: "https://mlwb.in/react-static-files/videos/gallery/video-2025-3.mp4",
    thumbnail: "https://mlwb.in/react-static-files/videos/gallery/thumbnails/video-2025-3.webp",
    poster: "https://mlwb.in/react-static-files/videos/gallery/thumbnails/video-2025-3.webp",
    type: "direct",
    date: "2025-03-15"
  }
];

export default videos2025;

